import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SupplierTaggingComponent } from './supplier-tagging.component';

const routes: Routes = [
  { path: '', component: SupplierTaggingComponent, data: { title: 'Supplier Tagging' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierTaggingRoutingModule {}

@NgModule({
  imports: [
    SupplierTaggingRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [SupplierTaggingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierTaggingModule {}
